// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";

var initialState = /* record */[
  /* contractCount */1,
  /* image */undefined,
  /* contractType : NoType */6,
  /* contracts : [] */0
];

function reducer(state, action) {
  if (typeof action === "number") {
    return /* record */[
            /* contractCount */state[/* contractCount */0],
            /* image */undefined,
            /* contractType */state[/* contractType */2],
            /* contracts */state[/* contracts */3]
          ];
  } else {
    switch (action.tag | 0) {
      case /* AddContract */0 :
          return /* record */[
                  /* contractCount */state[/* contractCount */0] + 1 | 0,
                  /* image */state[/* image */1],
                  /* contractType */state[/* contractType */2],
                  /* contracts : :: */[
                    /* tuple */[
                      "#" + (String(state[/* contractCount */0]) + (" " + action[0])),
                      action[1]
                    ],
                    state[/* contracts */3]
                  ]
                ];
      case /* ChangeType */1 :
          return /* record */[
                  /* contractCount */state[/* contractCount */0],
                  /* image */state[/* image */1],
                  /* contractType */action[0],
                  /* contracts */state[/* contracts */3]
                ];
      case /* SetImage */2 :
          return /* record */[
                  /* contractCount */state[/* contractCount */0],
                  /* image *//* tuple */[
                    action[0],
                    action[1]
                  ],
                  /* contractType */state[/* contractType */2],
                  /* contracts */state[/* contracts */3]
                ];
      
    }
  }
}

var stateContext = React.createContext(initialState);

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

var make = stateContext.Provider;

var StateProvider = {
  stateContext: stateContext,
  makeProps: makeProps,
  make: make
};

var dispatchContext = React.createContext((function (_action) {
        return /* () */0;
      }));

function makeProps$1(value, children, param) {
  return {
          value: value,
          children: children
        };
}

var make$1 = dispatchContext.Provider;

var DispatchProvider = {
  dispatchContext: dispatchContext,
  makeProps: makeProps$1,
  make: make$1
};

function XuderContext(Props) {
  var children = Props.children;
  var match = React.useReducer(reducer, initialState);
  return React.createElement(make, makeProps(match[0], React.createElement(make$1, makeProps$1(match[1], children, /* () */0)), /* () */0));
}

function useDispatch(param) {
  return React.useContext(dispatchContext);
}

function useState(param) {
  return React.useContext(stateContext);
}

var make$2 = XuderContext;

export {
  initialState ,
  reducer ,
  StateProvider ,
  DispatchProvider ,
  make$2 as make,
  useDispatch ,
  useState ,
  
}
/* stateContext Not a pure module */
